import React from 'react';
import Link from 'components/gruenland/atoms/link';
import Typography from 'components/gruenland/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import { Category } from 'types/entity/category';

interface ViewAllLinkProps {
  category: Category;
  onMenuClose: () => void;
  className?: string;
}

export const ViewAllLink: React.FC<ViewAllLinkProps> = ({ category, onMenuClose, className = 'mb-5 block' }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  if (!category || category.categoryId === 'myAccount') {
    return null;
  }

  const linkUrl = category._url || category.slug;

  if (!linkUrl) {
    return null;
  }

  return (
    <Link onClick={onMenuClose} link={linkUrl} className={className}>
      <Typography as="span" className="italic">
        {formatMessage({
          id: 'common.viewAll',
          defaultMessage: 'Visualizza tutto',
        })}
      </Typography>
    </Link>
  );
};
